import { TEN } from "@config/constants";
import memoize from "lodash/memoize";

export const getFullDecimalMultiplier = memoize((decimals: number): bigint => {
	return TEN ** BigInt(decimals);
});
